export type ITicksTo1970 = () => number;

export function _ticksTo1970(): number {
  return (
    ((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) + Math.floor(1970 / 400)) *
    24 *
    60 *
    60 *
    10000000
  );
}
